import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const calculatingFeeTask = createAsyncThunk('calculateFeeTask/calculatingFeeTask', async (key, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/calculate-fee-task-driver?transaction_key=${key}`);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});
